import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './account.routes';
import login from './login';
import settings from './settings';
import signup from './signup';
import testPaymentUi from '../../components/test-payment-ui';
export default angular.module('eeComUiApp.account', [
    'eeComUiApp.auth',
    uiRouter,
    login,
    settings,
    signup,
    testPaymentUi
])
    .config(routing)
    .run(function ($rootScope) {
    'ngInject';
    $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
        if (next.name === 'logout' && current && current.name && !current.authenticate) {
            next.referrer = current.name;
        }
    });
})
    .directive('progressBar', function () {
    return {
        restrict: 'E',
        replace: true,
        template: '<div class="loading text-center"><div class="loading-content"><p>File upload in progress...</p><progress-spinner hide-message="true"></progress-spinner></div></div>',
        link: function (scope, element, attr) {
            element.css('display', 'block');
        }
    };
})
    .name;
//# sourceMappingURL=index.js.map